import { ApiErrorCode, parseApiError } from '@ooh/contracts';
import { toast } from 'sonner';
import type { useTranslation } from 'react-i18next';

export type FinalizeToastKey =
  | 'workspace.header.toasts.approvalConflict'
  | 'workspace.header.toasts.approvalForbidden'
  | 'workspace.header.toasts.approvalError'
  | 'workspace.header.toasts.saleConflict'
  | 'workspace.header.toasts.saleForbidden'
  | 'workspace.header.toasts.saleError';

/** Shared error-classification for the confirm-campaign and record-sale
 * mutations (ConfirmCampaignDialog, RecordSaleDialog): both branch on the
 * same shape (409 + a specific conflict code -> conflict toast, 403 ->
 * forbidden toast, else -> generic toast), only the codes and toast keys
 * differ. */
export function handleFinalizeMutationError(
  error: unknown,
  t: ReturnType<typeof useTranslation<'offers'>>['t'],
  options: {
    conflictCode: ApiErrorCode;
    conflictToastKey: FinalizeToastKey;
    forbiddenToastKey: FinalizeToastKey;
    genericToastKey: FinalizeToastKey;
  },
): void {
  const parsedError = parseApiError(error);

  if (parsedError.statusCode === 409 && parsedError.errorCode === options.conflictCode) {
    toast.error(t(options.conflictToastKey));
    return;
  }

  if (parsedError.statusCode === 403) {
    toast.error(t(options.forbiddenToastKey));
    return;
  }

  toast.error(t(options.genericToastKey));
}
